import React, { useCallback, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { reduxForm, change } from "redux-form";
import { assignContentFeed } from "reducers/AssignContentFeed";
import { FEED_CREATION_FORM } from "forms/list";
import BaseContentFeedForm from "widgets/forms/contentfeeds/BaseContentFeedForm";
import FeedCreationStepper from "routes/contentfeeds/FeedCreationStepper";
import {
	buildAssignContentFeedArgs,
	createContentFeedNavigation
} from "utils/ContentFeedFormUtils";

import "./ContentFeedCreationSteps.css";

const STEP_NAMES = ["General Settings"];
const VALIDATION_FIELDS = ["feedName", "sourceUrl", "sourceType", "sheetName", "feedEmails"];

function AssignContentFeedForm({ libraryId, submitting, handleSubmit }) {
	const history = useHistory();
	const location = useLocation();
	const dispatch = useDispatch();

	const assignCreativeIds = location.state?.creativeIds;

	const { goBackToCreativesList, dispatchWithFeedsListRedirect } = useMemo(
		() => createContentFeedNavigation(history, libraryId),
		[history, libraryId]
	);

	// Set default values for assign flow
	useEffect(() => {
		dispatch(change(FEED_CREATION_FORM, 'autoUpdates', true));
		dispatch(change(FEED_CREATION_FORM, 'autoMapping', true));
	}, []);

	const handleAssignSave = useCallback((formValues) => {
		const { sourceUrl, sourceType, email, feedName, creativeIds, creativeLibraryId } =
			buildAssignContentFeedArgs(formValues, assignCreativeIds, libraryId);
		return dispatchWithFeedsListRedirect(
			dispatch(assignContentFeed(sourceUrl, sourceType, creativeIds, email, creativeLibraryId, feedName))
		);
	}, [assignCreativeIds, libraryId, dispatchWithFeedsListRedirect]);

	const onCancel = useCallback(() => {
		goBackToCreativesList();
	}, []);

	const formProps = {
		onSubmit: handleAssignSave,
		onCancel,
		submitButtonTitle: "Assign Bulk Sheet",
		reduxFormHandleSubmit: handleSubmit,
		isSaveLoading: submitting,
		validationFields: VALIDATION_FIELDS,
		showSourceFields: true,
		showSettingsFields: true,
		isAssignBlankFlow: false,
		isAssignFlow: true,
	};

	return (
		<>
			<FeedCreationStepper stepNames={STEP_NAMES} currentStep={0} />
			<BaseContentFeedForm {...formProps} />
		</>
	);
}

AssignContentFeedForm.propTypes = {
	libraryId: PropTypes.string.isRequired,
	submitting: PropTypes.bool,
	handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
	form: FEED_CREATION_FORM,
})(AssignContentFeedForm);
